import { useState } from "react";
import { Heart, Share2, Bookmark, User, ThumbsUp } from "lucide-react";
import api from "../../API/api";

export default function PublicationCard({
  title,
  image,
  text,
  id,
  authorName,
  authorFormation,
  authorAvatar = null,
  likeCount = 1,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [likes, setLikes] = useState(likeCount);
  const [isLiked, setIsLiked] = useState(false);

  const MAX_CHARS = 150;
  const shouldTruncate = text && text.length > MAX_CHARS;
  const displayText = isExpanded ? text : text?.substring(0, MAX_CHARS);

  const likeHandler = async () => {
    try {
      const result = await api.post(`v1/publications/${id}/like/`);
      if (result.status === 200) {
        setLikes(result.data.total_likes || likes + 1);
        setIsLiked(!isLiked);
        console.log("Publication liked successfully.");
      } else {
        console.error("Failed to like publication:", result);
      }
    } catch (error) {
      console.error("Failed to like publication:", error);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden w-full">
      {/* Cabeçalho com informações do autor */}
      <div className="flex items-start gap-3 p-5">
        {authorAvatar ? (
          <img
            src={authorAvatar}
            alt={authorName}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center flex-shrink-0">
            <User className="w-5 h-5 text-emerald-400" />
          </div>
        )}
        <div className="flex flex-col items-start">
          <h3 className="font-medium text-gray-800 text-sm">{authorName}</h3>
          <p className="text-xs text-gray-400">{authorFormation}</p>
        </div>
      </div>

      {/* Conteúdo */}
      <div className={`px-5 ${image ? "pb-3" : "pb-5"} text-left w-full`}>
        {title && (
          <h2 className="text-lg font-medium text-gray-800 mb-2">{title}</h2>
        )}
        <p className="text-gray-600 text-sm leading-relaxed">
          {displayText}
          {shouldTruncate && !isExpanded && "..."}
          {shouldTruncate && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-emerald-500 hover:text-emerald-600 font-medium ml-1 text-sm"
            >
              {isExpanded ? "Ver menos" : "Ver mais"}
            </button>
          )}
        </p>
      </div>

      {/* Imagem da publicação - apenas se existir */}
      {image && (
        <div className="px-5 pb-4">
          <img
            src={image}
            alt={title || "Publicação"}
            className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-lg"
          />
        </div>
      )}
    </div>
  );
}
